
module.exports = () => `go get github.com/flagsmith/flagsmith-go-client

import (
  "github.com/flagsmith/flagsmith-go-client"
)
`;
